import service from '../service.js'

export default {
    /**
     * 获取公司与关联账号信息列表
     * @returns 
     */
    GetCompanyAccountInformation: () => {
        return service({
            url: '/Companies/GetCompanyAccountInformation',
            method: 'get',
        })
    },
    /**
     * 添加公司与关联账号信息
     */
    AddCompanyAccountInformationn: (params) => {
        return service({
            url: '/Companies/AddCompanyAccountInformation',
            method: 'post',
            data: params
        })
    },
    /**
     * 删除公司和关联账号信息
     */
    DeleteConfirmed: (id) => {
        return service({
            url: '/Companies/DeleteConfirmed',
            method: 'post',
            params: { id }
        })
    },
}